import * as api from 'Shared/api';

export const getSmartLinkDetail =
  ({ url }) =>
  (dispatch, getState) => {
    const state = getState();

    dispatch({
      type: 'SMART_LINK_DETAIL_GET_REQUEST',
      payload: { url },
    });

    return api
      .getDocument({
        url,
        jwt_token: state.user.jwt_token,
        organization_id: state.organization.id,
      })
      .then(response => {
        if (!response) return;
        const json = response.data;

        dispatch({
          type: 'SMART_LINK_DETAIL_GET_RESPONSE',
          data: { ...json.data, url },
        });
      });

    // (josh) : removeing error handling that
    // was displaying a toast alert - this is only
    // used to enrich smart links and should
    // fail silently
  };
